import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { typography } from '@resiliatech/birdsong'
import { colors } from '../../../../Themes/Colors'

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const UserName = styled(Typography)`
  ${typography.up2.regularSans}
  color: ${colors.darkGrey};
`

export const UserEmail = styled(Typography)`
  ${typography.up1.regularSans}
  color: ${colors.mediumGrey};
`

export const StatusBadge = styled.span<{ intervened: boolean }>`
  color: ${({ intervened }) =>
    intervened ? colors.completedGreen : colors.paletteOrange};
  font-weight: 500;
`

export const TruncatedMessage = styled.span`
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
`

export const QuickTriggerSection = styled(Box)`
  margin-bottom: 24px;
  padding: 16px;
  background-color: ${colors.lightestGrey};
  border-radius: 4px;
`

export const QuickTriggerTitle = styled(Typography)`
  ${typography.up2.semiBoldSans}
  color: ${colors.darkGrey};
  margin-bottom: 8px;
`

export const ButtonContainer = styled(Box)`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`
